import { SvgIcon, SvgIconProps } from '@mui/material';
import { memo } from 'react';
const SvgAppIcon = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fill="#4B4B4A"
        d="M707.686 107.233c13.664 55.881 12.146 114.06 13.664 171.471 1.519 58.944 0 117.887-.759 177.595-.759 59.71-.759 118.652-2.277 178.361-.76 29.089-3.796 56.647-7.591 84.97-2.277 17.606-2.277 42.102-11.387 57.412-3.795 6.89-10.627 29.855-14.423 36.744-9.11 17.607-14.423 32.916-27.328 48.992-14.423 18.372-29.605 27.558-48.583 39.806-18.218 12.248-40.991 14.544-62.246 18.372-101.721 17.606-206.478-42.868-248.988-137.024-18.978-41.337-31.882-88.798-34.16-135.493-1.518-26.792-7.59-71.191 20.496-87.267-2.277 91.86 43.27 177.595 118.421 226.587 40.992 26.793 86.538 36.744 135.121 32.917 31.124-2.297 63.765-14.545 83.502-39.806 32.642-42.103 34.92-97.218 37.196-148.506 3.037-59.71.76-117.887-5.313-177.596-5.314-57.412-15.942-114.824-20.496-173.002-2.278-27.557-3.037-55.115-1.518-83.439 1.518-22.965 3.795-48.991 15.182-69.66 4.554-8.42 12.905-20.668 21.255-26.027 12.905-6.89 28.087 1.531 40.232 4.593"
      />
    </SvgIcon>
  );
};
const Memo = memo(SvgAppIcon);
export default Memo;
